"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _sum2 = _interopRequireDefault(require("lodash/sum"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _flatten2 = _interopRequireDefault(require("lodash/flatten"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _DataTableSource = _interopRequireDefault(require("./source/DataTableSource"));
var _tool = require("@entrylabs/tool");
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _tables = /*#__PURE__*/new WeakMap();
var _view = /*#__PURE__*/new WeakMap();
var _DataTable_brand = /*#__PURE__*/new WeakSet();
var DataTable = /*#__PURE__*/function () {
  function DataTable() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, DataTable);
    _classPrivateMethodInitSpec(this, _DataTable_brand);
    _classPrivateFieldInitSpec(this, _tables, []);
    _classPrivateFieldInitSpec(this, _view, void 0);
    (0, _defineProperty2["default"])(this, "modals", []);
    (0, _defineProperty2["default"])(this, "selected", void 0);
    (0, _defineProperty2["default"])(this, "saveTable", function (_ref) {
      var _Entry$creationChange;
      var selected = _ref.selected;
      _this.setSource(selected);
      Entry.playground.reloadPlayground();
      (_Entry$creationChange = Entry.creationChangedEvent) === null || _Entry$creationChange === void 0 || _Entry$creationChange.notify();
    });
    (0, _defineProperty2["default"])(this, "removeTable", function (index) {
      var _Entry$creationChange2;
      _classPrivateFieldSet(_tables, _this, (0, _filter2["default"])(_classPrivateFieldGet(_tables, _this), function (__, tIndex) {
        return index !== tIndex;
      }));
      (_Entry$creationChange2 = Entry.creationChangedEvent) === null || _Entry$creationChange2 === void 0 || _Entry$creationChange2.notify();
    });
    _assertClassBrand(_DataTable_brand, this, _generateView).call(this);
  }
  return (0, _createClass2["default"])(DataTable, [{
    key: "tables",
    get: function get() {
      return _classPrivateFieldGet(_tables, this);
    }
  }, {
    key: "dataTables",
    get: function get() {
      return (0, _map2["default"])(_classPrivateFieldGet(_tables, this), function (_ref2) {
        var id = _ref2.id,
          fields = _ref2.fields,
          chart = _ref2.chart,
          name = _ref2.name,
          origin = _ref2.origin,
          summary = _ref2.summary,
          provider = _ref2.provider,
          description = _ref2.description,
          fieldInfos = _ref2.fieldInfos;
        return {
          id: id,
          name: name,
          provider: provider,
          description: description,
          fieldInfos: fieldInfos,
          summary: summary,
          chart: (0, _cloneDeep2["default"])(chart),
          table: [(0, _toConsumableArray2["default"])(fields)].concat((0, _toConsumableArray2["default"])((0, _cloneDeep2["default"])(origin)))
        };
      });
    }
  }, {
    key: "removeAllBlocks",
    value: function removeAllBlocks() {
      var _EntryStatic$getAllBl = EntryStatic.getAllBlocks().find(function (_ref3) {
          var category = _ref3.category;
          return category === 'analysis';
        }),
        blocks = _EntryStatic$getAllBl.blocks;
      blocks.forEach(function (blockType) {
        Entry.Utils.removeBlockByType(blockType);
      });
      this.banAllBlock();
      this.clear();
    }
  }, {
    key: "banAllBlock",
    value: function banAllBlock() {
      Entry.playground.blockMenu.banClass('analysis');
    }
  }, {
    key: "unbanBlock",
    value: function unbanBlock() {
      Entry.playground.blockMenu.unbanClass('analysis');
    }
  }, {
    key: "getTables",
    value: function getTables() {
      var _this2 = this;
      var blockList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return (0, _uniq2["default"])((0, _flatten2["default"])(blockList.filter(function (block) {
        var _ref4 = block || {},
          _ref4$_schema = _ref4._schema,
          _schema = _ref4$_schema === void 0 ? {} : _ref4$_schema,
          _ref4$data = _ref4.data,
          data = _ref4$data === void 0 ? {} : _ref4$data;
        if (!data.type) {
          return false;
        }
        var isFor = _schema.isFor,
          _schema$isNotFor = _schema.isNotFor,
          isNotFor = _schema$isNotFor === void 0 ? [] : _schema$isNotFor;
        var _isNotFor = (0, _slicedToArray2["default"])(isNotFor, 1),
          key = _isNotFor[0];
        return key && isFor && key === 'analysis';
      }).map(function (block) {
        var _ref5 = block.data || {},
          _ref5$params = _ref5.params,
          params = _ref5$params === void 0 ? [] : _ref5$params;
        return params.filter(function (param) {
          if (typeof param !== 'string') {
            return false;
          }
          return (0, _find2["default"])(_classPrivateFieldGet(_tables, _this2), {
            id: param
          });
        });
      }))).map(function (tableId) {
        var table = _this2.getSource(tableId);
        return table.toJSON();
      });
    }
  }, {
    key: "getSource",
    value: function getSource(id) {
      if (!id) {
        console.warn('empty argument');
        return null;
      }
      return (0, _find2["default"])(_classPrivateFieldGet(_tables, this), {
        id: id
      }) || (0, _find2["default"])(_classPrivateFieldGet(_tables, this), {
        _id: id
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(_ref6) {
      var id = _ref6.id;
      if (!id) {
        console.warn('empty argument');
        return null;
      }
      return (0, _findIndex2["default"])(_classPrivateFieldGet(_tables, this), {
        id: id
      });
    }
  }, {
    key: "addSource",
    value: function addSource(table) {
      var view = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var data = table || {
        name: Lang.Workspace.data_table
      };
      data.name = Entry.getOrderedName(data.name, _classPrivateFieldGet(_tables, this), 'name');
      _classPrivateFieldGet(_tables, this).push(table instanceof _DataTableSource["default"] ? table : new _DataTableSource["default"](table));
      this.hide();
      if (view) {
        this.show({
          list: this.dataTables,
          selectedIndex: this.dataTables.length - 1
        });
      }
    }
  }, {
    key: "addSources",
    value: function addSources() {
      var _classPrivateFieldGet2;
      var tables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var dataTableSources = (0, _map2["default"])(tables, function (table) {
        return table instanceof _DataTableSource["default"] ? table : new _DataTableSource["default"](table);
      });
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_tables, this)).push.apply(_classPrivateFieldGet2, (0, _toConsumableArray2["default"])(dataTableSources));
      this.hide();
      this.show({
        list: this.dataTables,
        selectedIndex: this.dataTables.length - 1
      });
    }
  }, {
    key: "changeItemPosition",
    value: function changeItemPosition(start, end) {
      if (_classPrivateFieldGet(_tables, this).length) {
        _classPrivateFieldGet(_tables, this).splice(end, 0, _classPrivateFieldGet(_tables, this).splice(start, 1)[0]);
      }
    }
  }, {
    key: "setSource",
    value: function setSource(selected) {
      var chart = selected.chart,
        table = selected.table,
        name = selected.name,
        id = selected.id;
      var source = this.getSource(id);
      if (source) {
        source.modal = null;
        source.setArray({
          name: name,
          chart: chart,
          fields: table[0],
          data: table.slice(1)
        });
        source.updated = new Date();
      } else {
        var newSource = new _DataTableSource["default"]({
          chart: chart,
          data: table.slice(1),
          fields: table[0],
          name: name
        });
        _classPrivateFieldGet(_tables, this).push(newSource);
        selected.id = newSource.id;
      }
    }
  }, {
    key: "show",
    value: function show(data) {
      if (!this.dataAnalytics) {
        _assertClassBrand(_DataTable_brand, this, _generateView).call(this);
      }
      this.dataAnalytics.show(data || {
        selectedIndex: _classPrivateFieldGet(_tables, this).legnth - 1,
        list: this.dataTables
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.dataAnalytics && this.dataAnalytics.hide();
      if (_classPrivateFieldGet(_tables, this).length) {
        this.unbanBlock();
      } else {
        this.banAllBlock();
      }
      Entry.playground.reloadPlayground();
      Entry.playground.refreshPlayground();
      Entry.dispatchEvent('dismissModal');
    }
  }, {
    key: "getColumnIndex",
    value: function getColumnIndex(col) {
      if (Entry.Utils.isNumber(col)) {
        return parseFloat(col);
      }
      if (/[^A-Za-z]|\s/.test(col)) {
        return 0;
      }

      // return _.chain(col)
      //     .toUpper()
      //     .reduce((prev, curr) => prev * 26 + curr.charCodeAt() - 64, 0)
      //     .value();

      return (0, _sum2["default"])((0, _map2["default"])(col, function (cn, i) {
        return (cn.toUpperCase().charCodeAt(0) - 64) * Math.pow(26, col.length - i - 1);
      }));
    }
  }, {
    key: "getTableJSON",
    value: function getTableJSON() {
      return this.tables.filter(_.identity).map(function (v) {
        return v.toJSON ? v.toJSON() : v;
      });
    }
  }, {
    key: "setTables",
    value: function setTables() {
      var _this3 = this;
      var tables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if ((0, _isEmpty2["default"])(tables)) {
        return;
      }
      tables.forEach(function (table) {
        var data = table || {
          name: Lang.Workspace.data_table
        };
        data.name = Entry.getOrderedName(data.name, _classPrivateFieldGet(_tables, _this3), 'name');
        var isDataTableSource = data instanceof _DataTableSource["default"];
        _classPrivateFieldGet(_tables, _this3).push(isDataTableSource ? data : new _DataTableSource["default"](data));
      });
      tables.length && this.refreshPlayground();
    }
  }, {
    key: "refreshPlayground",
    value: function refreshPlayground() {
      var isWorkspace = Entry.type === 'workspace';
      if (isWorkspace) {
        this.unbanBlock();
        Entry.playground.reloadPlayground();
        Entry.playground.refreshPlayground();
      }
    }
  }, {
    key: "showChart",
    value: function showChart(tableId) {
      var chartIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.closeModal();
      var source = this.getSource(tableId);
      if (!source) {
        console.log("not exist souce, table id: ".concat(tableId));
        return;
      }
      var chart = source.modals.find(function (m) {
        return m.name === 'chart';
      });
      if (!chart) {
        chart = this.createChart(source, chartIndex);
        source.modals.push(chart);
        this.modals.push(chart);
      }
      source.forceApply();
      chart.show(undefined, {
        chartIndex: chartIndex
      });
    }
  }, {
    key: "showTable",
    value: function showTable(tableId) {
      this.closeModal();
      var source = this.getSource(tableId);
      if (!source) {
        console.log("not exist souce, table id: ".concat(tableId));
        return;
      }
      var table = source.modals.find(function (m) {
        return m.name === 'table';
      });
      if (!table) {
        table = this.createTable(source);
        source.modals.push(table);
        this.modals.push(table);
      }
      source.forceApply();
      table.show();
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modals.forEach(function (m) {
        m.hide();
      });
    }
  }, {
    key: "createChart",
    value: function createChart(source) {
      var chartIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _source$chart = source.chart,
        chart = _source$chart === void 0 ? [] : _source$chart,
        fields = source.fields,
        rows = source.rows;
      var container = Entry.Dom('div', {
        "class": 'entry-table-chart',
        parent: $(Entry.modalContainer)
      })[0];
      var modal = new _tool.ModalChart({
        data: {
          chartIndex: chartIndex,
          source: {
            fields: fields,
            origin: rows,
            chart: chart
          },
          togglePause: function togglePause() {
            return Entry.engine.togglePause();
          },
          stop: function stop() {
            return Entry.engine.toggleStop();
          },
          isIframe: self !== top
        },
        container: container
      });
      modal.name = 'chart';
      return modal;
    }
  }, {
    key: "createTable",
    value: function createTable(source) {
      var container = Entry.Dom('div', {
        "class": 'entry-table-modal',
        parent: $(Entry.modalContainer)
      })[0];
      var modal = new _tool.ModalTable({
        data: {
          table: source,
          tables: this.tables,
          stop: function stop() {
            return Entry.engine.toggleStop();
          },
          isIframe: self !== top,
          togglePause: function togglePause() {
            return Entry.engine.togglePause();
          }
        },
        container: container
      });
      modal.name = 'table';
      return modal;
    }
  }, {
    key: "clear",
    value: function clear() {
      _classPrivateFieldSet(_tables, this, []);
      this.modals = [];
    }
  }]);
}();
function _generateView() {
  var _this4 = this;
  var view = document.createElement('div');
  view.className = 'table-modal';
  document.body.appendChild(view);
  this.dataAnalytics = new _tool.DataAnalytics({
    container: view,
    data: {},
    isShow: false
  }).on('submit', this.saveTable).on('alert', function (_ref7) {
    var message = _ref7.message,
      _ref7$title = _ref7.title,
      title = _ref7$title === void 0 ? Lang.DataAnalytics.max_row_count_error_title : _ref7$title;
    return Entry.modal.alert(message, title);
  }).on('toast', function (message) {
    var title = message.title,
      content = message.content;
    Entry.toast.alert(title, content);
  }).on('close', /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _this4.hide();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }))).on('addTable', function () {
    Entry.dispatchEvent('openTableManager');
  }).on('removeTable', this.removeTable);
}
Entry.DataTable = new DataTable();
var _default = exports["default"] = Entry.DataTable;